import React, { useState, useEffect } from "react";
import Swal from 'sweetalert2';
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFilter,
  faDownload,
  faPrint,
  faFilePdf,
  faSearch,
  faSync,
  faSpinner,
  faUsers,
  faUserFriends,
  faUser,
  faChalkboardTeacher,
  faLayerGroup,
  faVenus,
  faMars,
  faSort,
  faSortUp,
  faSortDown,
  faTimes,
  faEye,
  faEdit,
  faFileExport,
  faSchool,
  faTable,
  faCalendar,
  faPhone,
  faIdCard,
  faHome,
  faMapMarkerAlt,
  faClipboardCheck,
  faUserCircle,
  faGraduationCap,
  faDatabase,
  faArchive,
  faEye as faEyeOpen,
  faChevronDown,
  faChevronUp,
  faCheckCircle,
  faTimesCircle,
  faEnvelope,
  faBirthdayCake,
  faCalendarAlt,
  faAddressCard,
  faList,
  faColumns,
  faFileAlt,
  faChartPie,
  faChartBar,
  faChartLine,
  faPercent,
  faStar,
  faAward,
  faTrophy,
  faMedal,
  faBookOpen,
  faBook,
  faClipboardList,
  faCalendarCheck,
  faUserGraduate,
  faChalkboard,
  faBan,
  faCheck,
  faCode,
  faHashtag
} from "@fortawesome/free-solid-svg-icons";
import "./ClasswiseStudents.css";
import Sidebar from "./Sidebar";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { PieChart, Pie, Cell, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LineChart, Line } from 'recharts';

const ClasswiseStudents = () => {
  const navigate = useNavigate();
  
  const [loading, setLoading] = useState(true);
  const [students, setStudents] = useState([]);
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [filters, setFilters] = useState({
    class: "",
    section: "",
    family_status: "",
    family_code: "",
    search: "",
    active_status: "",
    attendance: ""
  });
  const [availableClasses, setAvailableClasses] = useState([]);
  const [availableSections, setAvailableSections] = useState([]);
  const [stats, setStats] = useState({
    total: 0,
    boys: 0,
    girls: 0,
    solo: 0,
    family: 0,
    active: 0,
    inactive: 0
  });
  const [sortConfig, setSortConfig] = useState({
    key: "class",
    direction: "asc"
  });
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [showAllStudents, setShowAllStudents] = useState(true);
  const [viewMode, setViewMode] = useState("table");
  const [selectedRows, setSelectedRows] = useState(new Set());
  const [showArchived, setShowArchived] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [activeTab, setActiveTab] = useState("studentDetails");
  const [studentPerformance, setStudentPerformance] = useState(null);
  const [attendanceData, setAttendanceData] = useState(null);
  const [examResults, setExamResults] = useState([]);
  const [testResults, setTestResults] = useState([]);
  const [loadingDetails, setLoadingDetails] = useState(false);
  const [academicYearInfo, setAcademicYearInfo] = useState(null);
  const [recentAbsentees, setRecentAbsentees] = useState([]);
  const [todayAbsentCount, setTodayAbsentCount] = useState(0);
  const [blinkingButtonId, setBlinkingButtonId] = useState(null);

  const PHP_BASE_URL = "https://mhsdev.online/MHS-WEB/api";
  const STUDENTS_API = `${PHP_BASE_URL}/getStudents.php`;
  const DASHBOARD_API = `${PHP_BASE_URL}/dashboard.php`;
  const STUDENT_TESTS_API = `${PHP_BASE_URL}/getStudentTests.php`;
  const STUDENT_EXAMS_API = `${PHP_BASE_URL}/getStudentExams.php`;
  const UPDATE_STATUS_API = `${PHP_BASE_URL}/updateStudentStatus.php`;
  
  const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884D8', '#82CA9D'];
  
  const fetchStudents = async () => {
    setLoading(true);
    try {
      const params = {};
      if (filters.class) params.class = filters.class;
      if (filters.section) params.section = filters.section;
      if (filters.family_status) params.family_status = filters.family_status;
      if (filters.family_code) params.family_code = filters.family_code;
      if (filters.search) params.search = filters.search;
      if (filters.active_status) params.active_status = filters.active_status;
      
      const response = await axios.get(STUDENTS_API, { params });
      
      if (response.data && response.data.success) {
        const studentsData = response.data.data.students;
        
        // Normalize active_status to lowercase for consistent comparison
        const normalizedStudents = studentsData.map(student => ({
          ...student,
          active_status: (student.active_status || 'active').toLowerCase()
        }));
        
        setStudents(normalizedStudents);
        
        // Apply all filters
        let filtered = normalizedStudents;
        
        if (filters.search) {
          const searchTerm = filters.search.toLowerCase();
          filtered = filtered.filter(student => 
            student.name.toLowerCase().includes(searchTerm) ||
            student.father_name.toLowerCase().includes(searchTerm) ||
            student.student_id.toLowerCase().includes(searchTerm) ||
            student.mobile.includes(searchTerm) ||
            (student.family_code && student.family_code.toLowerCase().includes(searchTerm))
          );
        }
        
        if (filters.active_status) {
          filtered = filtered.filter(student => 
            student.active_status === filters.active_status.toLowerCase()
          );
        }
        
        if (filters.family_code) {
          const familyCodeTerm = filters.family_code.toLowerCase();
          filtered = filtered.filter(student => 
            student.family_code && student.family_code.toLowerCase().includes(familyCodeTerm)
          );
        }
        
        if (!showArchived) {
          filtered = filtered.filter(student => !student.archived);
        }
        
        if (filters.attendance) {
          if (filters.attendance === 'present') {
            filtered = filtered.filter(student => !student.isAbsentToday);
          } else if (filters.attendance === 'absent') {
            filtered = filtered.filter(student => student.isAbsentToday);
          }
        }
        
        setFilteredStudents(filtered);
        setAvailableClasses(response.data.data.filters.classes);
        setAvailableSections(response.data.data.filters.sections);
        
        // Use the overall stats from API response
        const apiStats = response.data.data.stats;
        
        // Debug log
        console.log('API Stats:', apiStats);
        console.log('Students count:', normalizedStudents.length);
        
        // Manually count for verification
        const activeCount = normalizedStudents.filter(s => s.active_status === 'active').length;
        const inactiveCount = normalizedStudents.filter(s => s.active_status === 'inactive').length;
        
        console.log('Manual counts - Active:', activeCount, 'Inactive:', inactiveCount);
        
        // Update stats with API data
        setStats({
          total: apiStats.total || normalizedStudents.length,
          boys: apiStats.boys || 0,
          girls: apiStats.girls || 0,
          solo: apiStats.solo || 0,
          family: apiStats.family || 0,
          active: activeCount, // Use manual count instead of API
          inactive: inactiveCount // Use manual count instead of API
        });
        
      } else {
        throw new Error(response.data?.error || "Failed to fetch students");
      }
    } catch (error) {
      console.error("Error fetching students:", error);
      
      // Fallback to sample data
      const sampleData = generateSampleData();
      setStudents(sampleData);
      setFilteredStudents(sampleData);
      setAvailableClasses(["Play Group", "Nursery", "Prep", "Class 1", "Class 2", "Class 3", "Class 4", "Class 5", "Class 6", "Class 7", "Class 8", "Class 9", "Class 10"]);
      setAvailableSections(["A", "B", "C"]);
      
      // Calculate sample stats
      const activeCount = sampleData.filter(s => s.active_status === 'active').length;
      const inactiveCount = sampleData.filter(s => s.active_status === 'inactive').length;
      const boysCount = sampleData.filter(s => s.gender === 'Male').length;
      const girlsCount = sampleData.filter(s => s.gender === 'Female').length;
      const soloCount = sampleData.filter(s => s.family_status === 'solo').length;
      const familyCount = sampleData.filter(s => s.family_status === 'family').length;
      
      setStats({
        total: sampleData.length,
        boys: boysCount,
        girls: girlsCount,
        solo: soloCount,
        family: familyCount,
        active: activeCount,
        inactive: inactiveCount
      });
      
      // Show error message
      Swal.fire({
        title: 'Warning',
        text: 'Using sample data due to API error. Check console for details.',
        icon: 'warning',
        confirmButtonColor: '#3085d6',
      });
    } finally {
      setLoading(false);
    }
  };

  const [updatingStudentId, setUpdatingStudentId] = useState(null);

const handleBanStudent = async (student) => {
  const newStatus = student.active_status === 'active' ? 'inactive' : 'active';
  const actionType = newStatus === 'inactive' ? 'Ban' : 'Activate';
  
  const result = await Swal.fire({
    title: `Are you sure?`,
    text: `Do you want to ${newStatus === 'inactive' ? 'ban' : 'activate'} student ${student.name}?`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: newStatus === 'inactive' ? '#d33' : '#3085d6',
    cancelButtonColor: '#aaa',
    confirmButtonText: `Yes, ${actionType} student!`,
    cancelButtonText: 'Cancel'
  });
  
  if (result.isConfirmed) {
    try {
      setUpdatingStudentId(student.id);
      
      // Update in database
      const response = await axios.post(UPDATE_STATUS_API, {
        student_id: student.student_id,
        active_status: newStatus
      });
      
      if (response.data && response.data.success) {
        // Update local state
        const updatedStudents = students.map(s => 
          s.id === student.id ? { ...s, active_status: newStatus } : s
        );
        setStudents(updatedStudents);
        
        // Apply current filters to updated data
        let filtered = updatedStudents;
        if (filters.search) {
          const searchTerm = filters.search.toLowerCase();
          filtered = filtered.filter(s => 
            s.name.toLowerCase().includes(searchTerm) ||
            s.father_name.toLowerCase().includes(searchTerm) ||
            s.student_id.toLowerCase().includes(searchTerm) ||
            s.mobile.includes(searchTerm) ||
            (s.family_code && s.family_code.toLowerCase().includes(searchTerm))
          );
        }
        if (filters.active_status) {
          filtered = filtered.filter(s => s.active_status === filters.active_status);
        }
        if (filters.family_code) {
          const familyCodeTerm = filters.family_code.toLowerCase();
          filtered = filtered.filter(s => 
            s.family_code && s.family_code.toLowerCase().includes(familyCodeTerm)
          );
        }
        if (!showArchived) {
          filtered = filtered.filter(s => !s.archived);
        }
        setFilteredStudents(filtered);
        
        // Update stats
        const activeCount = updatedStudents.filter(s => s.active_status === 'active').length;
        const inactiveCount = updatedStudents.filter(s => s.active_status === 'inactive').length;
        setStats(prev => ({ ...prev, active: activeCount, inactive: inactiveCount }));
        
        // Set blinking effect for the updated button
        setBlinkingButtonId(student.id);
        setTimeout(() => setBlinkingButtonId(null), 2000);
        
        Swal.fire({
          title: 'Success!',
          text: `Student has been ${newStatus === 'inactive' ? 'banned' : 'activated'} successfully.`,
          icon: 'success',
          confirmButtonColor: '#3085d6',
        });
      } else {
        throw new Error(response.data?.error || "Failed to update status");
      }
    } catch (error) {
      console.error("Error updating student status:", error);
      
      // --- 🚨 CUSTOM WARNING MODAL FOR BLOCKED ACTIONS ---
      let errorMessage = 'Failed to update student status. Please try again.';
      let familyCode = student.family_code;
      
      // Extract error message from response
      if (error.response) {
        if (error.response.data && error.response.data.error) {
          errorMessage = error.response.data.error;
          // If backend sends family_code, use it
          if (error.response.data.family_code) {
            familyCode = error.response.data.family_code;
          }
        } else if (typeof error.response.data === 'string') {
          errorMessage = error.response.data;
        }
      } else if (error.message) {
        errorMessage = error.message;
      }
      
      // Check if this is an unpaid fees error
      const isUnpaidError = errorMessage.toLowerCase().includes('unpaid') ||
                            errorMessage.toLowerCase().includes('pending') ||
                            errorMessage.toLowerCase().includes('clear all pending') ||
                            errorMessage.toLowerCase().includes('monthly fee') ||
                            errorMessage.toLowerCase().includes('initial setup');
      
      if (isUnpaidError) {
        Swal.fire({
          title: '⚠️ Action Blocked',
          html: `
            <div style="text-align: left;">
              <p style="font-size: 16px; margin-bottom: 15px; color: #2c3e50;">
                ${errorMessage}
              </p>
              <div style="background: #fff3cd; border-left: 4px solid #ffc107; padding: 16px; margin: 20px 0; border-radius: 6px;">
                <strong style="color: #856404; display: flex; align-items: center; gap: 8px;">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <circle cx="12" cy="12" r="10" stroke-width="2"/>
                    <line x1="12" y1="8" x2="12" y2="12" stroke-width="2"/>
                    <circle cx="12" cy="16" r="1" fill="currentColor"/>
                  </svg>
                  Required Action:
                </strong>
                <p style="margin: 12px 0 0 0; color: #856404; line-height: 1.5;">
                  All pending monthly fees and initial setup fees must be cleared before changing student status.
                  Please visit the family payment page to resolve outstanding dues.
                </p>
              </div>
              ${familyCode ? `
                <div style="background: #e7f5ff; border-left: 4px solid #3498db; padding: 12px; margin-top: 15px; border-radius: 4px;">
                  <strong style="color: #1e5f7a;">🏠 Family Code:</strong> 
                  <code style="background: #fff; padding: 4px 8px; border-radius: 4px; margin-left: 8px;">${familyCode}</code>
                </div>
              ` : ''}
            </div>
          `,
          icon: 'warning',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK, I Understand',
          showCancelButton: !!familyCode,
          cancelButtonColor: '#6c757d',
          cancelButtonText: 'View Family Payments',
          customClass: {
            popup: 'swal-wide'
          },
          width: '600px'
        }).then((result) => {
          if (result.dismiss === Swal.DismissReason.cancel && familyCode) {
            // Navigate to family payment page with the family code
            navigate(`/pay-family-fee?FC=${familyCode}`);
          }
        });
      } else {
        // Generic error for other issues
        Swal.fire({
          title: 'Error!',
          text: errorMessage,
          icon: 'error',
          confirmButtonColor: '#d33',
          confirmButtonText: 'OK'
        });
      }
    } finally {
      setUpdatingStudentId(null);
    }
  }
};

  const fetchRecentAbsentees = async () => {
    try {
      const response = await axios.get(`${DASHBOARD_API}?action=getRecentAbsenteesNew`);
      
      if (response.data && response.data.success) {
        setRecentAbsentees(response.data.recent_absentees || []);
        setTodayAbsentCount(response.data.today_absent || 0);
        setAcademicYearInfo(response.data.academic_year_info);
        
        // Update student attendance status
        updateStudentAttendanceStatus(response.data.recent_absentees);
      }
    } catch (error) {
      console.error("Error fetching recent absentees:", error);
    }
  };

  const updateStudentAttendanceStatus = (absenteesData) => {
    // Create a map of absent student IDs for today
    const today = new Date().toISOString().split('T')[0]; // YYYY-MM-DD format
    const absentStudentIds = new Set();
    
    if (absenteesData && Array.isArray(absenteesData)) {
      absenteesData.forEach(absentee => {
        if (absentee.marked_at === today) {
          absentStudentIds.add(absentee.student_id);
        }
      });
    }
    
    // Update students with today's attendance status
    setStudents(prevStudents => 
      prevStudents.map(student => ({
        ...student,
        isAbsentToday: absentStudentIds.has(student.student_id)
      }))
    );
    
    setFilteredStudents(prevStudents => 
      prevStudents.map(student => ({
        ...student,
        isAbsentToday: absentStudentIds.has(student.student_id)
      }))
    );
  };
  
  const fetchStudentDetails = async (student) => {
    if (!student) return;
    
    setLoadingDetails(true);
    try {
      // Fetch multiple data in parallel
      const [performanceRes, attendanceRes, examRes, testRes] = await Promise.all([
        axios.get(`${DASHBOARD_API}?action=getPerformanceMetrics`),
        axios.get(`${DASHBOARD_API}?action=getRecentAbsenteesNew`),
        axios.get(`${STUDENT_EXAMS_API}?student_id=${student.student_id}`),
        axios.get(`${STUDENT_TESTS_API}?student_id=${student.student_id}`)
      ]);
      
      if (performanceRes.data.success) {
        setStudentPerformance(performanceRes.data);
      }
      
      if (attendanceRes.data.success) {
        const studentAttendance = processAttendanceData(attendanceRes.data, student);
        setAttendanceData(studentAttendance);
      }
      
      // DEBUG: Log exam API response
      console.log('Exam API Response:', examRes.data);
      console.log('Student ID used:', student.student_id);
      
      if (examRes.data.success && examRes.data.examResults) {
        console.log('Exam Results found:', examRes.data.examResults);
        console.log('Number of exams:', examRes.data.examResults.length);
        setExamResults(examRes.data.examResults);
      } else {
        console.error("No exam data found or API error:", examRes.data);
        setExamResults([]);
      }
      
      // DEBUG: Log test API response
      console.log('Test API Response:', testRes.data);
      
      if (testRes.data.success && testRes.data.testResults) {
        console.log('Test Results found:', testRes.data.testResults);
        console.log('Number of tests:', testRes.data.testResults.length);
        setTestResults(testRes.data.testResults);
      } else {
        console.error("No test data found or API error:", testRes.data);
        setTestResults([]);
      }
      
    } catch (error) {
      console.error("Error fetching student details:", error);
      // Fallback to fetching by class if student-specific fails
      try {
        if (selectedStudent) {
          const [examByClassRes, testByClassRes] = await Promise.all([
            axios.get(`${STUDENT_EXAMS_API}?class=${selectedStudent.class}`),
            axios.get(`${STUDENT_TESTS_API}?class=${selectedStudent.class}`)
          ]);
          
          console.log('Exam by class response:', examByClassRes.data);
          console.log('Test by class response:', testByClassRes.data);
          
          if (examByClassRes.data.success) {
            setExamResults(examByClassRes.data.examResults);
          }
          
          if (testByClassRes.data.success) {
            setTestResults(testByClassRes.data.testResults);
          }
        }
      } catch (fallbackError) {
        console.error("Fallback fetch also failed:", fallbackError);
        setExamResults([]);
        setTestResults([]);
      }
    } finally {
      setLoadingDetails(false);
    }
  };
  
  const processAttendanceData = (attendanceData, student) => {
    if (!attendanceData || !attendanceData.recent_absentees) {
      return generateSampleAttendance(student);
    }
    
    const today = new Date().toISOString().split('T')[0]; // YYYY-MM-DD format
    
    // Find if student is absent today from recent absentees
    const studentAbsentToday = attendanceData.recent_absentees.find(
      abs => abs.student_id === student.student_id && abs.marked_at === today
    );
    
    // Count total absences for this student
    const studentAbsences = attendanceData.recent_absentees.filter(
      abs => abs.student_id === student.student_id
    );
    
    // Calculate attendance statistics
    const totalDays = 180; // Assuming 180 school days
    const absentDays = studentAbsences.length;
    const presentDays = totalDays - absentDays;
    const attendanceRate = totalDays > 0 ? Math.round((presentDays / totalDays) * 100) : 0;
    
    // Generate monthly data based on absences
    const monthlyData = generateMonthlyAttendanceData(studentAbsences);
    
    return {
      isPresent: !studentAbsentToday,
      lastAttendance: today,
      attendanceRate: attendanceRate,
      totalDays: totalDays,
      presentDays: presentDays,
      absentDays: absentDays,
      monthlyData: monthlyData,
      recentAbsences: studentAbsences.slice(0, 10) // Last 10 absences
    };
  };
  
  const generateMonthlyAttendanceData = (absences) => {
    // Group absences by month
    const monthlyMap = {};
    
    absences.forEach(absence => {
      const date = new Date(absence.marked_at);
      const monthYear = date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
      
      if (!monthlyMap[monthYear]) {
        monthlyMap[monthYear] = { present: 22, absent: 0 }; // Assume 22 school days per month
      }
      monthlyMap[monthYear].absent += 1;
      monthlyMap[monthYear].present -= 1;
    });
    
    // Convert to array and sort by date
    return Object.entries(monthlyMap)
      .map(([month, data]) => ({
        month: month.split(' ')[0], // Just month name
        present: Math.max(0, data.present),
        absent: data.absent
      }))
      .sort((a, b) => {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        return months.indexOf(a.month) - months.indexOf(b.month);
      });
  };
  
  const generateSampleData = () => {
    const names = ["Ali Raza", "Ahmad Khan", "Fatima Bibi", "Sara Ahmed", "Hassan Ali", "Zainab Noor", "Omar Farooq", "Khadija Hussain", "Usman Malik", "Ayesha Khan"];
    const fatherNames = ["Muhammad", "Ahmed", "Hussain", "Raza", "Abbas", "Jawad", "Ali", "Zain", "Hassan", "Akbar"];
    const classes = ["Play Group", "Nursery", "Prep", "Class 1", "Class 2", "Class 3", "Class 4", "Class 5", "Class 6", "Class 7", "Class 8", "Class 9", "Class 10"];
    const sections = ["A", "B", "C"];
    const familyCodes = ["FAM-001", "FAM-002", "FAM-003", "FAM-004", "FAM-005", "FAM-006", "FAM-007", "FAM-008", "FAM-009", "FAM-010", "", null];
    
    return Array.from({ length: 50 }, (_, i) => ({
      id: i + 1,
      name: names[Math.floor(Math.random() * names.length)],
      father_name: fatherNames[Math.floor(Math.random() * fatherNames.length)],
      mobile: "03" + Math.floor(Math.random() * 100000000).toString().padStart(8, "0"),
      b_form_no: "B-" + (10000 + i).toString(),
      address: `House #${Math.floor(Math.random() * 100)}, Street ${Math.floor(Math.random() * 50)}, Lahore`,
      gender: Math.random() > 0.5 ? "Male" : "Female",
      class: classes[Math.floor(Math.random() * classes.length)],
      section: sections[Math.floor(Math.random() * sections.length)],
      student_id: "STD-" + (2024000 + i).toString(),
      family_status: Math.random() > 0.7 ? "solo" : "family",
      family_code: familyCodes[Math.floor(Math.random() * familyCodes.length)],
      active_status: Math.random() > 0.3 ? 'active' : 'inactive',
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
      email: `student${i+1}@school.edu.pk`,
      dob: `200${Math.floor(Math.random() * 5)}-${(Math.floor(Math.random() * 12) + 1).toString().padStart(2, '0')}-${(Math.floor(Math.random() * 28) + 1).toString().padStart(2, '0')}`,
      admission_date: `2023-0${Math.floor(Math.random() * 9) + 1}-${(Math.floor(Math.random() * 28) + 1).toString().padStart(2, '0')}`,
      archived: Math.random() > 0.9,
      active: true,
      isAbsentToday: Math.random() > 0.8 // Random attendance status for sample
    }));
  };
  
  const generateSamplePerformance = () => ({
    class_performance: [
      { class: 'Class 9', avg_percentage: 85.5, min_percentage: 60, max_percentage: 98 },
      { class: 'Class 10', avg_percentage: 82.3, min_percentage: 55, max_percentage: 96 }
    ],
    grade_distribution: [
      { grade: 'A++', count: 25, percentage: 15.2 },
      { grade: 'A+', count: 40, percentage: 24.4 },
      { grade: 'A', count: 35, percentage: 21.3 },
      { grade: 'B+', count: 30, percentage: 18.3 },
      { grade: 'B', count: 20, percentage: 12.2 },
      { grade: 'C', count: 10, percentage: 6.1 },
      { grade: 'F', count: 4, percentage: 2.4 }
    ]
  });
  
  const generateSampleAttendance = (student) => {
    const isAbsent = Math.random() > 0.7;
    const today = new Date().toISOString().split('T')[0];
    
    return {
      isPresent: !isAbsent,
      lastAttendance: today,
      attendanceRate: Math.floor(Math.random() * 20) + 80,
      totalDays: 180,
      presentDays: 150,
      absentDays: 30,
      monthlyData: [
        { month: 'Jan', present: 22, absent: 2 },
        { month: 'Feb', present: 20, absent: 4 },
        { month: 'Mar', present: 23, absent: 1 },
        { month: 'Apr', present: 21, absent: 3 },
        { month: 'May', present: 22, absent: 2 },
      ]
    };
  };
  
  const generateSampleExamData = (student) => {
    if (!student) return [];
    
    const subjects = ['Mathematics', 'Science', 'English', 'Urdu', 'Islamiat', 'Computer'];
    const examTypes = ['1st Assessment', 'Mid Term', '2nd Assessment', 'Final'];
    
    return examTypes.map((examType, index) => ({
      examType,
      exam_no: index + 1,
      date: new Date(2024, index * 3, 15).toISOString().split('T')[0],
      exam_day: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'][index % 5],
      class: student.class,
      section: student.section,
      student_id: student.student_id,
      student_name: student.name,
      subjects: subjects.map(subject => ({
        subject,
        obtained: Math.floor(Math.random() * 40) + 60,
        total: 100,
        percentage: Math.floor(Math.random() * 20) + 70
      }))
    }));
  };
  
  useEffect(() => {
    fetchStudents();
    fetchRecentAbsentees();
  }, [filters.class, filters.section, filters.family_status, filters.family_code, filters.active_status]);
  
  useEffect(() => {
    let result = students;
    
    if (filters.search) {
      const searchTerm = filters.search.toLowerCase();
      result = result.filter(student => 
        student.name.toLowerCase().includes(searchTerm) ||
        student.father_name.toLowerCase().includes(searchTerm) ||
        student.student_id.toLowerCase().includes(searchTerm) ||
        student.mobile.includes(searchTerm) ||
        (student.family_code && student.family_code.toLowerCase().includes(searchTerm))
      );
    }
    
    if (filters.active_status) {
      result = result.filter(student => student.active_status === filters.active_status);
    }
    
    if (filters.family_code) {
      const familyCodeTerm = filters.family_code.toLowerCase();
      result = result.filter(student => 
        student.family_code && student.family_code.toLowerCase().includes(familyCodeTerm)
      );
    }
    
    if (!showArchived) {
      result = result.filter(student => !student.archived);
    }
    
    if (filters.attendance) {
      if (filters.attendance === 'present') {
        result = result.filter(student => !student.isAbsentToday);
      } else if (filters.attendance === 'absent') {
        result = result.filter(student => student.isAbsentToday);
      }
    }
    
    setFilteredStudents(result);
  }, [filters.search, filters.active_status, filters.family_code, filters.attendance, students, showArchived]);
  
  const handleFilterChange = (filterName, value) => {
    setFilters(prev => ({ ...prev, [filterName]: value }));
  };
  
  const handleSearch = (e) => {
    const value = e.target.value;
    setFilters(prev => ({ ...prev, search: value }));
  };
  
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    
    setSortConfig({ key, direction });
    
    const sorted = [...filteredStudents].sort((a, b) => {
      let aValue = a[key];
      let bValue = b[key];
      
      if (key === "class") {
        const classOrder = {
          "Play Group": 1, "Nursery": 2, "Prep": 3,
          "Class 1": 4, "Class 2": 5, "Class 3": 6,
          "Class 4": 7, "Class 5": 8, "Class 6": 9,
          "Class 7": 10, "Class 8": 11, "Class 9": 12,
          "Class 10": 13
        };
        aValue = classOrder[a.class] || 99;
        bValue = classOrder[b.class] || 99;
      }
      
      if (key === "name" || key === "father_name" || key === "family_code") {
        aValue = aValue?.toLowerCase();
        bValue = bValue?.toLowerCase();
      }
      
      if (aValue < bValue) return direction === "asc" ? -1 : 1;
      if (aValue > bValue) return direction === "asc" ? 1 : -1;
      return 0;
    });
    
    setFilteredStudents(sorted);
  };
  
  const clearFilters = () => {
    setFilters({
      class: "",
      section: "",
      family_status: "",
      family_code: "",
      search: "",
      active_status: "",
      attendance: ""
    });
  };
  
  const getSortIcon = (key) => {
    if (sortConfig.key !== key) return faSort;
    return sortConfig.direction === "asc" ? faSortUp : faSortDown;
  };
  
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };
  
  const formatDateOnly = (dateString) => {
    if (!dateString) return "N/A";
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) {
        return dateString; // Return original if invalid date
      }
      return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      });
    } catch (error) {
      console.error("Error formatting date:", error);
      return dateString;
    }
  };
  
  const toggleRowSelection = (studentId) => {
    const newSelected = new Set(selectedRows);
    if (newSelected.has(studentId)) {
      newSelected.delete(studentId);
    } else {
      newSelected.add(studentId);
    }
    setSelectedRows(newSelected);
  };
  
  const selectAllRows = () => {
    if (selectedRows.size === filteredStudents.length) {
      setSelectedRows(new Set());
    } else {
      const allIds = filteredStudents.map(student => student.id);
      setSelectedRows(new Set(allIds));
    }
  };
  
  const toggleArchived = (student) => {
    const updatedStudents = students.map(s => 
      s.id === student.id ? { ...s, archived: !s.archived } : s
    );
    setStudents(updatedStudents);
  };
  
  const archiveSelected = () => {
    const updatedStudents = students.map(s => 
      selectedRows.has(s.id) ? { ...s, archived: true } : s
    );
    setStudents(updatedStudents);
    setSelectedRows(new Set());
  };
  
  const restoreSelected = () => {
    const updatedStudents = students.map(s => 
      selectedRows.has(s.id) ? { ...s, archived: false } : s
    );
    setStudents(updatedStudents);
    setSelectedRows(new Set());
  };
  
  const openModal = (student) => {
    setSelectedStudent(student);
    setActiveTab("studentDetails");
    setIsModalOpen(true);
    setIsModalVisible(true);
    fetchStudentDetails(student);
  };
  
  const closeModal = () => {
    setIsModalVisible(false);
    setTimeout(() => {
      setIsModalOpen(false);
      setSelectedStudent(null);
      setStudentPerformance(null);
      setAttendanceData(null);
      setExamResults([]);
      setTestResults([]);
    }, 300);
  };
  
  const generatePDF = () => {
    setPdfLoading(true);

    try {
      const doc = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4"
      });

      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const margin = 15;

      const loadImage = (url) => {
        return new Promise((resolve) => {
          const img = new Image();
          img.src = url;
          img.crossOrigin = 'anonymous';
          img.onload = () => resolve(img);
          img.onerror = () => resolve(null);
        });
      };

      const loadImages = async () => {
        const [logoLeft, logoRight, stampImg, bubbleImg] = await Promise.all([
          loadImage('/images/logo.jpg'),
          loadImage('/images/l2.png'),
          loadImage('/images/stamp.png'),
          loadImage('/images/bubble.png')
        ]);
        return { logoLeft, logoRight, stampImg, bubbleImg };
      };

      const drawBubbles = (doc) => {
        doc.setGState(new doc.GState({ opacity: 0.03 }));

        const bubbleColors = [
          [200, 200, 255],
          [220, 230, 255],
          [240, 240, 240]
        ];

        for (let i = 0; i < 15; i++) {
          const color = bubbleColors[Math.floor(Math.random() * bubbleColors.length)];
          const x = Math.random() * pageWidth;
          const y = Math.random() * pageHeight;
          const radius = 5 + Math.random() * 15;

          doc.setFillColor(color[0], color[1], color[2]);
          doc.circle(x, y, radius, 'F');
        }

        doc.setGState(new doc.GState({ opacity: 1.0 }));
      };

      const createHeader = async (doc, images) => {
        const headerHeight = 40;

        doc.setFillColor(255, 255, 255);
        doc.rect(0, 0, pageWidth, headerHeight, 'F');

        doc.setFillColor(255, 215, 0);
        doc.rect(0, 0, pageWidth, 3, 'F');

        if (images.logoLeft) {
          const logoWidth = 30;
          const logoHeight = (images.logoLeft.height * logoWidth) / images.logoLeft.width;
          const logoY = (headerHeight - logoHeight) / 2;
          doc.addImage(images.logoLeft, 'JPEG', margin, logoY, logoWidth, logoHeight);
        }

        if (images.logoRight) {
          const logoWidth = 30;
          const logoHeight = (images.logoRight.height * logoWidth) / images.logoRight.width;
          const logoY = (headerHeight - logoHeight) / 2;
          doc.addImage(images.logoRight, 'PNG', pageWidth - margin - logoWidth, logoY, logoWidth, logoHeight);
        }

        doc.setFontSize(24);
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(44, 50, 146);
        doc.text('DAR-E-ARQAM SCHOOL', pageWidth / 2, 15, { align: 'center' });

        doc.setFontSize(10);
        doc.setFont('helvetica', 'normal');
        doc.setTextColor(44, 50, 146);
        doc.text('KOTLI LOHARAN EAST CAMPUS', pageWidth / 2, 22, { align: 'center' });
        doc.text('Affiliated with Punjab Group of Colleges', pageWidth / 2, 27, { align: 'center' });

        doc.setFontSize(8);
        doc.setTextColor(100, 100, 100);
        doc.text('Phone: +92 300 1234567', margin + 35, 32);
        doc.text('Email: info@dar-e-arqam.edu.pk', pageWidth - margin - 35, 32, { align: 'right' });

        return headerHeight;
      };

      const createTitleSection = (doc, headerHeight) => {
        const titleY = headerHeight + 10;

        doc.setFillColor(245, 247, 255);
        doc.roundedRect(margin, titleY, pageWidth - 2 * margin, 25, 3, 3, 'F');

        doc.setFontSize(18);
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(44, 50, 146);
        doc.text('STUDENT DIRECTORY REPORT', pageWidth / 2, titleY + 10, { align: 'center' });

        doc.setFontSize(10);
        doc.setFont('helvetica', 'normal');
        doc.setTextColor(100, 100, 100);
        doc.text('Academic Session 2024-2025', pageWidth / 2, titleY + 17, { align: 'center' });

        return titleY + 30;
      };

      const createInfoSection = (doc, startY) => {
        const infoY = startY;

        doc.setFontSize(9);
        doc.setTextColor(0, 0, 0);

        const currentDate = new Date().toLocaleDateString('en-US', {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        });

        doc.text(`Generated: ${currentDate}`, margin, infoY);
        doc.text(`Total Students: ${filteredStudents.length}`, margin, infoY + 5);

        const generatedTime = new Date().toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit'
        });

        doc.text(`Time: ${generatedTime}`, pageWidth - margin, infoY, { align: 'right' });
        doc.text(`Report ID: DIR-${new Date().getTime().toString().slice(-6)}`, pageWidth - margin, infoY + 5, { align: 'right' });

        return infoY + 15;
      };

      const createTable = async (doc, startY, images) => {
        const headers = [
          ['S.No', 'Student ID', 'Student Name', 'Father Name', 'Mobile', 'Gender', 'Class', 'Section', 'Family Status', 'Family Code', 'Active Status']
        ];

        const tableData = filteredStudents.map((student, index) => [
          index + 1,
          student.student_id,
          student.name,
          student.father_name,
          student.mobile,
          student.gender,
          student.class,
          student.section,
          student.family_status,
          student.family_code || 'N/A',
          student.active_status === 'active' ? 'Active' : 'Inactive'
        ]);

        autoTable(doc, {
          startY: startY,
          head: headers,
          body: tableData,
          theme: 'grid',
          headStyles: {
            fillColor: [44, 50, 146],
            textColor: 255,
            fontSize: 9,
            fontStyle: 'bold',
            halign: 'center'
          },
          bodyStyles: {
            fontSize: 8,
            cellPadding: 3,
            textColor: [50, 50, 50],
            halign: 'left'
          },
          alternateRowStyles: {
            fillColor: [245, 247, 255]
          },
          margin: { left: margin, right: margin },
          didDrawPage: function(data) {
            const pageCount = doc.internal.getNumberOfPages();
            doc.setFontSize(8);
            doc.setTextColor(100);
            doc.text(
              `Page ${data.pageNumber} of ${pageCount}`,
              pageWidth / 2,
              pageHeight - 10,
              { align: 'center' }
            );
          },
          styles: {
            lineColor: [220, 220, 220],
            lineWidth: 0.1
          },
          columnStyles: {
            0: { halign: 'center' },
            5: { halign: 'center' },
            6: { halign: 'center' },
            7: { halign: 'center' },
            8: { halign: 'center' },
            9: { halign: 'center' },
            10: { halign: 'center', cellWidth: 25 }
          }
        });
      };

      const createFooter = (doc, images) => {
        const footerY = pageHeight - 30;

        if (images.stampImg) {
          doc.setGState(new doc.GState({ opacity: 0.9 }));
          const stampWidth = 40;
          const stampHeight = (images.stampImg.height * stampWidth) / images.stampImg.width;
          doc.addImage(
            images.stampImg,
            'PNG',
            pageWidth - margin - stampWidth,
            footerY - 5,
            stampWidth,
            stampHeight
          );
          doc.setGState(new doc.GState({ opacity: 1.0 }));
          doc.setFontSize(7);
          doc.setTextColor(150);
          doc.text('OFFICIAL SEAL', pageWidth - margin - 20, footerY + stampHeight + 5, { align: 'center' });
        }
      };

      const generatePDFContent = async () => {
        try {
          const images = await loadImages();

          drawBubbles(doc);

          const headerHeight = await createHeader(doc, images);

          const titleEndY = createTitleSection(doc, headerHeight);

          const infoEndY = createInfoSection(doc, titleEndY);

          await createTable(doc, infoEndY, images);

          createFooter(doc, images);

          doc.setGState(new doc.GState({ opacity: 0.05 }));
          doc.setFontSize(60);
          doc.setFont('helvetica', 'bold');
          doc.setTextColor(200, 200, 200);
          doc.text('CONFIDENTIAL', pageWidth / 2, pageHeight / 2, {
            align: 'center',
            angle: 45
          });
          doc.setGState(new doc.GState({ opacity: 1.0 }));

        } catch (error) {
          console.error('Error in PDF generation:', error);
          generateFallbackPDF(doc);
        }
      };

      const generateFallbackPDF = (doc) => {
        doc.setFontSize(16);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(0,0,0);
        doc.text("STUDENT DIRECTORY REPORT", pageWidth / 2, 20, { align: "center" });

        const tableData = filteredStudents.map(student => [
          student.student_id,
          student.name,
          student.father_name,
          student.mobile,
          student.gender,
          student.class,
          student.section,
          student.family_status,
          student.family_code || "N/A",
          student.active_status === 'active' ? 'Active' : 'Inactive'
        ]);

        autoTable(doc, {
          startY: 30,
          head: [['ID', 'Name', 'Father Name', 'Mobile', 'Gender', 'Class', 'Section', 'Family Status', 'Family Code', 'Active Status']],
          body: tableData,
          theme: 'grid',
          headStyles: {
            fillColor: [44, 50, 146],
            textColor: 255,
            fontSize: 9,
            fontStyle: 'bold'
          },
          bodyStyles: {
            fontSize: 8,
            cellPadding: 3
          },
          margin: { left: margin, right: margin }
        });
      };

      generatePDFContent().then(() => {
        const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
        doc.save(`Dar-e-Arqam_Student_Directory_${timestamp}.pdf`);

        setPdfLoading(false);
      }).catch(error => {
        console.error('Error generating PDF:', error);
        setPdfLoading(false);
        Swal.fire({
          title: 'PDF Generation Error',
          text: 'Failed to generate PDF. Please try again.',
          icon: 'error',
          confirmButtonColor: '#d33',
        });
      });

    } catch (error) {
      console.error("Error in PDF generation setup:", error);
      setPdfLoading(false);
    }
  };

  const renderStudentDetailsTab = () => {
    if (!selectedStudent) return null;
    
    return (
      <div className="classwise-students-student-details-tab">
        <div className="classwise-students-info-section">
          <h4>
            <FontAwesomeIcon icon={faUser} />
            Personal Information
          </h4>
          <div className="classwise-students-info-grid">
            <div className="classwise-students-info-item">
              <span className="classwise-students-info-label">Full Name:</span>
              <span className="classwise-students-info-value">{selectedStudent.name}</span>
            </div>
            <div className="classwise-students-info-item">
              <span className="classwise-students-info-label">Father's Name:</span>
              <span className="classwise-students-info-value">{selectedStudent.father_name}</span>
            </div>
            <div className="classwise-students-info-item">
              <span className="classwise-students-info-label">Gender:</span>
              <span className={`classwise-students-info-value classwise-students-gender ${selectedStudent.gender?.toLowerCase()}`}>
                <FontAwesomeIcon icon={selectedStudent.gender === 'Male' ? faMars : faVenus} />
                {selectedStudent.gender}
              </span>
            </div>
            <div className="classwise-students-info-item">
              <span className="classwise-students-info-label">Date of Birth:</span>
              <span className="classwise-students-info-value">
                <FontAwesomeIcon icon={faBirthdayCake} />
                {formatDate(selectedStudent.dob)}
              </span>
            </div>
            <div className="classwise-students-info-item">
              <span className="classwise-students-info-label">B-Form No:</span>
              <span className="classwise-students-info-value">
                <FontAwesomeIcon icon={faAddressCard} />
                {selectedStudent.b_form_no}
              </span>
            </div>
            <div className="classwise-students-info-item">
              <span className="classwise-students-info-label">Active Status:</span>
              <span className={`classwise-students-info-value classwise-students-status ${selectedStudent.active_status === 'active' ? 'classwise-students-active' : 'classwise-students-inactive'}`}>
                <FontAwesomeIcon icon={selectedStudent.active_status === 'active' ? faCheckCircle : faTimesCircle} />
                {selectedStudent.active_status === 'active' ? 'Active' : 'Inactive'}
              </span>
            </div>
          </div>
        </div>
        
        <div className="classwise-students-info-section">
          <h4>
            <FontAwesomeIcon icon={faGraduationCap} />
            Academic Information
          </h4>
          <div className="classwise-students-info-grid">
            <div className="classwise-students-info-item">
              <span className="classwise-students-info-label">Class:</span>
              <span className="classwise-students-info-value">
                <FontAwesomeIcon icon={faSchool} />
                {selectedStudent.class}
              </span>
            </div>
            <div className="classwise-students-info-item">
              <span className="classwise-students-info-label">Section:</span>
              <span className="classwise-students-section-badge-modal">
                {selectedStudent.section}
              </span>
            </div>
            <div className="classwise-students-info-item">
              <span className="classwise-students-info-label">Admission Date:</span>
              <span className="classwise-students-info-value">
                <FontAwesomeIcon icon={faCalendarAlt} />
                {formatDate(selectedStudent.admission_date)}
              </span>
            </div>
            <div className="classwise-students-info-item">
              <span className="classwise-students-info-label">Archive Status:</span>
              <span className={`classwise-students-info-value classwise-students-status ${selectedStudent.archived ? 'classwise-students-archived' : 'classwise-students-active'}`}>
                <FontAwesomeIcon icon={selectedStudent.archived ? faArchive : faCheckCircle} />
                {selectedStudent.archived ? 'Archived' : 'Active'}
              </span>
            </div>
          </div>
        </div>
        
        <div className="classwise-students-info-section">
          <h4>
            <FontAwesomeIcon icon={faPhone} />
            Contact Information
          </h4>
          <div className="classwise-students-info-grid">
            <div className="classwise-students-info-item">
              <span className="classwise-students-info-label">Mobile:</span>
              <span className="classwise-students-info-value">
                <FontAwesomeIcon icon={faPhone} />
                {selectedStudent.mobile}
              </span>
            </div>
            <div className="classwise-students-info-item">
              <span className="classwise-students-info-label">Email:</span>
              <span className="classwise-students-info-value">
                <FontAwesomeIcon icon={faEnvelope} />
                {selectedStudent.email}
              </span>
            </div>
            <div className="classwise-students-info-item classwise-students-full-width">
              <span className="classwise-students-info-label">Address:</span>
              <span className="classwise-students-info-value classwise-students-address">
                <FontAwesomeIcon icon={faMapMarkerAlt} />
                {selectedStudent.address}
              </span>
            </div>
          </div>
        </div>
        
        <div className="classwise-students-info-section">
          <h4>
            <FontAwesomeIcon icon={faHome} />
            Family Information
          </h4>
          <div className="classwise-students-info-grid">
            <div className="classwise-students-info-item">
              <span className="classwise-students-info-label">Family Status:</span>
              <span className={`classwise-students-info-value classwise-students-family-status-modal ${selectedStudent.family_status}`}>
                <FontAwesomeIcon icon={selectedStudent.family_status === 'family' ? faUserFriends : faUser} />
                {selectedStudent.family_status}
              </span>
            </div>
            <div className="classwise-students-info-item">
              <span className="classwise-students-info-label">Family Code:</span>
              <span className="classwise-students-info-value">
                <FontAwesomeIcon icon={faCode} />
                {selectedStudent.family_code || 'Not Assigned'}
              </span>
            </div>
          </div>
        </div>
        
        <div className="classwise-students-info-section">
          <h4>
            <FontAwesomeIcon icon={faDatabase} />
            System Information
          </h4>
          <div className="classwise-students-info-grid">
            <div className="classwise-students-info-item">
              <span className="classwise-students-info-label">Created:</span>
              <span className="classwise-students-info-value">
                <FontAwesomeIcon icon={faCalendar} />
                {formatDate(selectedStudent.created_at)}
              </span>
            </div>
            <div className="classwise-students-info-item">
              <span className="classwise-students-info-label">Last Updated:</span>
              <span className="classwise-students-info-value">
                <FontAwesomeIcon icon={faCalendar} />
                {formatDate(selectedStudent.updated_at)}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  };
  
  const renderAttendanceReportTab = () => {
    if (!attendanceData || loadingDetails) {
      return (
        <div className="classwise-students-loading-details">
          <FontAwesomeIcon icon={faSpinner} spin />
          <p>Loading attendance data...</p>
        </div>
      );
    }
    
    const attendancePieData = [
      { name: 'Present', value: attendanceData.presentDays, color: '#10b981' },
      { name: 'Absent', value: attendanceData.absentDays, color: '#ef4444' }
    ];
    
    const overallAttendance = attendanceData.attendanceRate;
    
    return (
      <div className="classwise-students-attendance-report-tab">
        <div className="classwise-students-attendance-summary">
          <div className="classwise-students-summary-card">
            <div className="classwise-students-summary-icon classwise-students-present">
              <FontAwesomeIcon icon={faCheckCircle} />
            </div>
            <div className="classwise-students-summary-content">
              <h3>{attendanceData.presentDays}</h3>
              <p>Days Present</p>
            </div>
          </div>
          
          <div className="classwise-students-summary-card">
            <div className="classwise-students-summary-icon classwise-students-absent">
              <FontAwesomeIcon icon={faTimesCircle} />
            </div>
            <div className="classwise-students-summary-content">
              <h3>{attendanceData.absentDays}</h3>
              <p>Days Absent</p>
            </div>
          </div>
          
          <div className="classwise-students-summary-card">
            <div className="classwise-students-summary-icon classwise-students-rate">
              <FontAwesomeIcon icon={faPercent} />
            </div>
            <div className="classwise-students-summary-content">
              <h3>{overallAttendance}%</h3>
              <p>Attendance Rate</p>
            </div>
          </div>
          
          <div className="classwise-students-summary-card">
            <div className="classwise-students-summary-icon classwise-students-total">
              <FontAwesomeIcon icon={faCalendarCheck} style={{color:'white'}}/>
            </div>
            <div className="classwise-students-summary-content">
              <h3>{attendanceData.totalDays}</h3>
              <p>Total Days</p>
            </div>
          </div>
        </div>
        
        <div className="classwise-students-attendance-charts">
          <div className="classwise-students-chart-container">
            <h4>Attendance Distribution</h4>
            <div className="classwise-students-chart-wrapper">
              <ResponsiveContainer width="100%" height={300}>
                <PieChart>
                  <Pie
                    data={attendancePieData}
                    cx="50%"
                    cy="50%"
                    labelLine={false}
                    label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                    outerRadius={80}
                    fill="#8884d8"
                    dataKey="value"
                  >
                    {attendancePieData.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={entry.color} />
                    ))}
                  </Pie>
                  <Tooltip />
                  <Legend />
                </PieChart>
              </ResponsiveContainer>
            </div>
          </div>
          
          <div className="classwise-students-chart-container">
            <h4>Monthly Attendance Trend</h4>
            <div className="classwise-students-chart-wrapper">
              <ResponsiveContainer width="100%" height={300}>
                <BarChart data={attendanceData.monthlyData}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="month" />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Bar dataKey="present" name="Present Days" fill="#10b981" />
                  <Bar dataKey="absent" name="Absent Days" fill="#ef4444" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
        
        <div className="classwise-students-attendance-details">
          <h4>Today's Attendance Status</h4>
          <div className="classwise-students-attendance-status">
            <span className={`classwise-students-status-badge ${attendanceData.isPresent ? 'classwise-students-present' : 'classwise-students-absent'}`}>
              <FontAwesomeIcon icon={attendanceData.isPresent ? faCheckCircle : faTimesCircle} />
              Today: {attendanceData.isPresent ? 'Present' : 'Absent'}
            </span>
            <span className="classwise-students-last-attendance">
              <FontAwesomeIcon icon={faCalendarAlt} />
              Last Recorded: {attendanceData.lastAttendance}
            </span>
          </div>
          
          <div className="classwise-students-monthly-breakdown">
            <h5>Monthly Breakdown</h5>
            <div className="classwise-students-monthly-list">
              {attendanceData.monthlyData.map((month, index) => (
                <div key={index} className="classwise-students-month-item">
                  <span className="classwise-students-month-name">{month.month}</span>
                  <div className="classwise-students-month-stats">
                    <span className="classwise-students-present-count">{month.present} days</span>
                    <span className="classwise-students-absent-count">{month.absent} days</span>
                    <span className="classwise-students-month-percentage">
                      {((month.present / (month.present + month.absent)) * 100).toFixed(0)}%
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  };
  
  const renderTestReportTab = () => {
    if (loadingDetails) {
      return (
        <div className="classwise-students-loading-details">
          <FontAwesomeIcon icon={faSpinner} spin />
          <p>Loading test data...</p>
        </div>
      );
    }
    
    if (!testResults || testResults.length === 0) {
      return (
        <div className="classwise-students-no-data">
          <FontAwesomeIcon icon={faClipboardList} />
          <h4>No Test Results Available</h4>
          <p>No test data found for this student in the database.</p>
        </div>
      );
    }
    
    // Calculate subject averages from real data
    const subjectPerformance = testResults.flatMap(test => 
      test.subjects.map(subject => ({
        subject: subject.subject,
        percentage: subject.percentage,
        test: test.testName
      }))
    );
    
    const subjectGroups = {};
    subjectPerformance.forEach(item => {
      if (!subjectGroups[item.subject]) {
        subjectGroups[item.subject] = [];
      }
      subjectGroups[item.subject].push(item);
    });
    
    const subjectAverages = Object.entries(subjectGroups).map(([subject, tests]) => {
      const avg = tests.reduce((sum, test) => sum + test.percentage, 0) / tests.length;
      return { subject, average: avg.toFixed(1) };
    });
    
    return (
      <div className="classwise-students-test-report-tab">
        <div className="classwise-students-test-summary">
          <div className="classwise-students-summary-header">
            <h4>Test Performance Summary</h4>
            <span className="classwise-students-total-tests">
              {testResults.length} Tests Completed
            </span>
          </div>
          
          {subjectAverages.length > 0 && (
            <div className="classwise-students-subject-chart">
              <h5>Subject-wise Average Performance</h5>
              <div className="classwise-students-chart-wrapper">
                <ResponsiveContainer width="100%" height={300}>
                  <BarChart data={subjectAverages}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="subject" />
                    <YAxis domain={[0, 100]} />
                    <Tooltip formatter={(value) => [`${value}%`, 'Average']} />
                    <Bar dataKey="average" name="Average %" fill="#4f46e5">
                      {subjectAverages.map((entry, index) => (
                        <Cell 
                          key={`cell-${index}`} 
                          fill={entry.average >= 80 ? '#10b981' : 
                                entry.average >= 60 ? '#f59e0b' : '#ef4444'} 
                        />
                      ))}
                    </Bar>
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
          )}
        </div>
        
        <div className="classwise-students-test-details">
          <h4>Detailed Test Results</h4>
          <div className="classwise-students-tests-list">
            {testResults.map((test, testIndex) => {
              const testAverage = test.subjects.reduce((sum, sub) => sum + sub.percentage, 0) / test.subjects.length;
              
              return (
                <div key={testIndex} className="classwise-students-test-card">
                  <div className="classwise-students-test-header">
                    <h5>{test.testName} (Test #{test.test_no})</h5>
                    <div className="classwise-students-test-meta">
                      <span className="classwise-students-test-date">
                        {formatDateOnly(test.date)} ({test.test_day})
                      </span>
                      <span className="classwise-students-test-average">
                        {testAverage.toFixed(1)}%
                      </span>
                    </div>
                  </div>
                  <div className="classwise-students-test-subjects">
                    {test.subjects.map((subject, subIndex) => (
                      <div key={subIndex} className="classwise-students-subject-result">
                        <span className="classwise-students-subject-name">{subject.subject}</span>
                        <div className="classwise-students-subject-marks">
                          <span className="classwise-students-obtained">{subject.obtained.toFixed(1)}</span>
                          <span className="classwise-students-separator">/</span>
                          <span className="classwise-students-total">{subject.total}</span>
                        </div>
                        <span className={`classwise-students-percentage ${subject.percentage >= 80 ? 'classwise-students-excellent' : subject.percentage >= 60 ? 'classwise-students-good' : 'classwise-students-poor'}`}>
                          {subject.percentage.toFixed(1)}%
                        </span>
                      </div>
                    ))}
                  </div>
                  <div className="classwise-students-test-summary">
                    <div className="classwise-students-summary-item">
                      <span>Highest:</span>
                      <strong>{Math.max(...test.subjects.map(s => s.percentage)).toFixed(1)}%</strong>
                    </div>
                    <div className="classwise-students-summary-item">
                      <span>Lowest:</span>
                      <strong>{Math.min(...test.subjects.map(s => s.percentage)).toFixed(1)}%</strong>
                    </div>
                    <div className="classwise-students-summary-item">
                      <span>Average:</span>
                      <strong>{testAverage.toFixed(1)}%</strong>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };
  
  const renderExamReportTab = () => {
    if (loadingDetails) {
      return (
        <div className="classwise-students-loading-details">
          <FontAwesomeIcon icon={faSpinner} spin />
          <p>Loading exam data...</p>
        </div>
      );
    }
    
    // Use sample data if no real data, but show a button to load sample for testing
    const displayExamResults = examResults && examResults.length > 0 
      ? examResults 
      : [];
    
    if (!displayExamResults || displayExamResults.length === 0) {
      return (
        <div className="classwise-students-no-data">
          <FontAwesomeIcon icon={faBookOpen} />
          <h4>No Exam Results Available</h4>
          <p>No exam data found for this student in the database.</p>
          <button 
            className="classwise-students-btn-secondary"
            onClick={() => {
              // Add sample data button for testing
              const sampleData = generateSampleExamData(selectedStudent);
              setExamResults(sampleData);
            }}
          >
            Load Sample Data for Testing
          </button>
        </div>
      );
    }
    
    // Calculate overall average from real data
    const overallAverage = displayExamResults.reduce((total, exam) => {
      const examAvg = exam.subjects.reduce((sum, sub) => sum + sub.percentage, 0) / exam.subjects.length;
      return total + examAvg;
    }, 0) / displayExamResults.length;
    
    const grade = overallAverage >= 90 ? 'A++' :
                 overallAverage >= 80 ? 'A+' :
                 overallAverage >= 70 ? 'A' :
                 overallAverage >= 60 ? 'B+' :
                 overallAverage >= 50 ? 'B' :
                 overallAverage >= 40 ? 'C' : 'F';
    
    const gradeColors = {
      'A++': '#10b981',
      'A+': '#10b981',
      'A': '#3b82f6',
      'B+': '#f59e0b',
      'B': '#f59e0b',
      'C': '#ef4444',
      'F': '#dc2626'
    };
    
    // Prepare data for trend chart
    const examTrendData = displayExamResults.map((exam, index) => {
      const examAverage = exam.subjects.reduce((sum, sub) => sum + sub.percentage, 0) / exam.subjects.length;
      return {
        name: exam.examType,
        average: examAverage,
        date: exam.date
      };
    }).sort((a, b) => new Date(a.date) - new Date(b.date)); // Sort by date
    
    // Calculate subject performance for chart
    const allSubjects = {};
    displayExamResults.forEach(exam => {
      exam.subjects.forEach(subject => {
        if (!allSubjects[subject.subject]) {
          allSubjects[subject.subject] = {
            subject: subject.subject,
            totalPercentage: 0,
            count: 0
          };
        }
        allSubjects[subject.subject].totalPercentage += subject.percentage;
        allSubjects[subject.subject].count++;
      });
    });
    
    const subjectAverages = Object.values(allSubjects).map(subject => ({
      subject: subject.subject,
      average: (subject.totalPercentage / subject.count).toFixed(1)
    }));
    
    return (
      <div className="classwise-students-exam-report-tab">
        <div className="classwise-students-exam-overview">
          <div className="classwise-students-overview-card">
            <div className="classwise-students-overview-icon">
              <FontAwesomeIcon icon={faTrophy} />
            </div>
            <div className="classwise-students-overview-content">
              <h3>{overallAverage.toFixed(1)}%</h3>
              <p>Overall Average</p>
            </div>
          </div>
          
          <div className="classwise-students-overview-card">
            <div className="classwise-students-overview-icon" style={{ color: gradeColors[grade] }}>
              <FontAwesomeIcon icon={faAward} />
            </div>
            <div className="classwise-students-overview-content">
              <h3 style={{ color: gradeColors[grade] }}>{grade}</h3>
              <p>Current Grade</p>
            </div>
          </div>
          
          <div className="classwise-students-overview-card">
            <div className="classwise-students-overview-icon">
              <FontAwesomeIcon icon={faChartLine} />
            </div>
            <div className="classwise-students-overview-content">
              <h3>{displayExamResults.length}</h3>
              <p>Exams Taken</p>
            </div>
          </div>
          
          <div className="classwise-students-overview-card">
            <div className="classwise-students-overview-icon">
              <FontAwesomeIcon icon={faBook} />
            </div>
            <div className="classwise-students-overview-content">
              <h3>{displayExamResults[0]?.subjects.length || 0}</h3>
              <p>Subjects</p>
            </div>
          </div>
        </div>
        
        {subjectAverages.length > 0 && (
          <div className="classwise-students-exam-performance">
            <h4>Subject-wise Average Performance</h4>
            <div className="classwise-students-chart-wrapper">
              <ResponsiveContainer width="100%" height={300}>
                <BarChart data={subjectAverages}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="subject" />
                  <YAxis domain={[0, 100]} />
                  <Tooltip formatter={(value) => [`${value}%`, 'Average']} />
                  <Bar dataKey="average" name="Average %" fill="#4f46e5">
                    {subjectAverages.map((entry, index) => (
                      <Cell 
                        key={`cell-${index}`} 
                        fill={entry.average >= 80 ? '#10b981' : 
                              entry.average >= 60 ? '#f59e0b' : '#ef4444'} 
                      />
                    ))}
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        )}
        
        {examTrendData.length > 0 && (
          <div className="classwise-students-exam-performance">
            <h4>Exam Performance Trend</h4>
            <div className="classwise-students-chart-wrapper">
              <ResponsiveContainer width="100%" height={300}>
                <LineChart data={examTrendData}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis domain={[0, 100]} />
                  <Tooltip formatter={(value) => [`${value.toFixed(1)}%`, 'Average']} />
                  <Legend />
                  <Line 
                    type="monotone" 
                    dataKey="average" 
                    name="Exam Average" 
                    stroke="#4f46e5" 
                    strokeWidth={2} 
                    dot={{ r: 6 }} 
                    activeDot={{ r: 8 }}
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>
        )}
        
        <div className="classwise-students-exam-details">
          <h4>Detailed Exam Results</h4>
          <div className="classwise-students-exams-list">
            {displayExamResults.map((exam, examIndex) => {
              const examAverage = exam.subjects.reduce((sum, sub) => sum + sub.percentage, 0) / exam.subjects.length;
              
              return (
                <div key={examIndex} className="classwise-students-exam-card">
                  <div className="classwise-students-exam-header">
                    <h5>{exam.examType} Exam (Exam #{exam.exam_no})</h5>
                    <div className="classwise-students-exam-meta">
                      <span className="classwise-students-exam-date">
                        {formatDateOnly(exam.date)} ({exam.exam_day})
                      </span>
                      <span className="classwise-students-exam-average">{examAverage.toFixed(1)}%</span>
                    </div>
                  </div>
                  
                  <div className="classwise-students-exam-subjects">
                    {exam.subjects.map((subject, subIndex) => {
                      const subjectGrade = subject.percentage >= 90 ? 'A++' :
                                          subject.percentage >= 80 ? 'A+' :
                                          subject.percentage >= 70 ? 'A' :
                                          subject.percentage >= 60 ? 'B+' :
                                          subject.percentage >= 50 ? 'B' :
                                          subject.percentage >= 40 ? 'C' : 'F';
                      
                      const gradeColor = subject.percentage >= 90 ? '#10b981' :
                                       subject.percentage >= 80 ? '#3b82f6' :
                                       subject.percentage >= 70 ? '#3b82f6' :
                                       subject.percentage >= 60 ? '#f59e0b' :
                                       subject.percentage >= 50 ? '#f59e0b' :
                                       subject.percentage >= 40 ? '#ef4444' : '#dc2626';
                      
                      return (
                        <div key={subIndex} className="classwise-students-subject-row">
                          <span className="classwise-students-subject-name">{subject.subject}</span>
                          <div className="classwise-students-subject-performance">
                            <div className="classwise-students-marks">
                              <span className="classwise-students-obtained">{subject.obtained.toFixed(1)}</span>
                              <span className="classwise-students-separator">/</span>
                              <span className="classwise-students-total">{subject.total}</span>
                            </div>
                            <span className={`classwise-students-percentage ${subject.percentage >= 80 ? 'classwise-students-excellent' : subject.percentage >= 60 ? 'classwise-students-good' : 'classwise-students-poor'}`}>
                              {subject.percentage.toFixed(1)}%
                            </span>
                            <div 
                              className="classwise-students-grade-badge"
                              style={{ backgroundColor: gradeColor + '20', color: gradeColor }}
                            >
                              {subjectGrade}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  
                  <div className="classwise-students-exam-summary">
                    <div className="classwise-students-summary-item">
                      <span>Highest:</span>
                      <strong>{Math.max(...exam.subjects.map(s => s.percentage)).toFixed(1)}%</strong>
                    </div>
                    <div className="classwise-students-summary-item">
                      <span>Lowest:</span>
                      <strong>{Math.min(...exam.subjects.map(s => s.percentage)).toFixed(1)}%</strong>
                    </div>
                    <div className="classwise-students-summary-item">
                      <span>Average:</span>
                      <strong>{examAverage.toFixed(1)}%</strong>
                    </div>
                    <div className="classwise-students-summary-item">
                      <span>Status:</span>
                      <strong style={{ 
                        color: examAverage >= 60 ? '#10b981' : '#ef4444',
                        backgroundColor: examAverage >= 60 ? '#10b98120' : '#ef444420',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        fontSize: '12px'
                      }}>
                        {examAverage >= 60 ? 'Pass' : 'Fail'}
                      </strong>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };
  
  const renderTabContent = () => {
    switch (activeTab) {
      case 'studentDetails':
        return renderStudentDetailsTab();
      case 'testReport':
        return renderTestReportTab();
      case 'examReport':
        return renderExamReportTab();
      case 'attendanceReport':
        return renderAttendanceReportTab();
      default:
        return renderStudentDetailsTab();
    }
  };

  const statsStyles = {
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
      gap: '20px',
      marginBottom: '30px',
    },
    card: {
      backgroundColor: '#ffffff',
      padding: '20px',
      borderRadius: '12px',
      display: 'flex',
      alignItems: 'center',
      gap: '16px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
      border: '1px solid #edf2f7',
    },
    iconBox: (bgColor, iconColor) => ({
      width: '48px',
      height: '48px',
      borderRadius: '10px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: bgColor,
      color: iconColor,
      fontSize: '20px',
    }),
    content: {
      display: 'flex',
      flexDirection: 'column',
    },
    value: {
      fontSize: '22px',
      fontWeight: '700',
      color: '#1a202c',
      margin: 0,
      lineHeight: '1.2',
    },
    label: {
      fontSize: '14px',
      color: '#718096',
      margin: 0,
      fontWeight: '500',
      marginTop: '4px',
    }
  };

  return (
    <div className="classwise-students-dashboard-wrapper">
      <Sidebar />
      
      <div className="classwise-students-main-content">
        <header className="classwise-students-page-header">
          <div className="classwise-students-header-main">
            <div className="classwise-students-header-title">
              <FontAwesomeIcon icon={faDatabase} className="classwise-students-header-icon" />
              <div>
                <h1>Student Directory</h1>
                <p className="classwise-students-subtitle">Complete student management system</p>
                {academicYearInfo && (
                  <p className="classwise-students-academic-year-info">
                    Academic Year: {academicYearInfo.academic_year || '2025-2026'} | 
                    Today's Absent: {todayAbsentCount} students
                  </p>
                )}
              </div>
            </div>
            <div className="classwise-students-header-actions">
              <button 
                className="classwise-students-btn-action classwise-students-primary"
                onClick={generatePDF}
                disabled={pdfLoading || filteredStudents.length === 0}
              >
                <FontAwesomeIcon icon={pdfLoading ? faSpinner : faFilePdf} spin={pdfLoading} />
                {pdfLoading ? 'Generating PDF...' : 'Export PDF'}
              </button>
              <button 
                className="classwise-students-btn-action classwise-students-secondary"
                onClick={() => {
                  fetchStudents();
                  fetchRecentAbsentees();
                }}
              >
                <FontAwesomeIcon icon={faSync} />
                Refresh
              </button>
            </div>
          </div>
        </header>
        
        <div style={statsStyles.grid}>
          {[
            { label: 'Total Students', value: stats.total, icon: faUsers, bg: '#ebf8ff', color: '#3182ce' },
            { label: 'Boys', value: stats.boys, icon: faMars, bg: '#eef2ff', color: '#4f46e5' },
            { label: 'Girls', value: stats.girls, icon: faVenus, bg: '#fff5f7', color: '#d53f8c' },
            { label: 'Solo Students', value: stats.solo, icon: faUser, bg: '#f0fff4', color: '#38a169' },
            { label: 'Family Students', value: stats.family, icon: faUserFriends, bg: '#fffaf0', color: '#dd6b20' },
            { label: 'Active Students', value: stats.active, icon: faCheckCircle, bg: '#d1fae5', color: '#059669' },
            { label: 'Inactive Students', value: stats.inactive, icon: faBan, bg: '#fee2e2', color: '#dc2626' },
            { label: 'Archived', value: students.filter(s => s.archived).length, icon: faArchive, bg: '#f7fafc', color: '#4a5568' },
            { label: 'Absent Today', value: todayAbsentCount, icon: faTimesCircle, bg: '#fff5f5', color: '#f56565' },
            { label: 'Recent Absences', value: recentAbsentees.length, icon: faCalendar, bg: '#fffaf0', color: '#ed8936' },
          ].map((item, index) => (
            <div key={index} style={statsStyles.card}>
              <div style={statsStyles.iconBox(item.bg, item.color)}>
                <FontAwesomeIcon icon={item.icon} />
              </div>
              <div style={statsStyles.content}>
                <h3 style={statsStyles.value}>{item.value}</h3>
                <p style={statsStyles.label}>{item.label}</p>
              </div>
            </div>
          ))}
        </div>
        
        <div className="classwise-students-controls-bar">
          <div className="classwise-students-controls-left">
            <div className="classwise-students-view-toggle">
              <button 
                className={`classwise-students-view-btn ${viewMode === 'table' ? 'classwise-students-active' : ''}`}
                onClick={() => setViewMode('table')}
              >
                <FontAwesomeIcon icon={faTable} />
                Detailed View
              </button>
              <button 
                className={`classwise-students-view-btn ${viewMode === 'condensed' ? 'classwise-students-active' : ''}`}
                onClick={() => setViewMode('condensed')}
              >
                <FontAwesomeIcon icon={faList} />
                Condensed View
              </button>
            </div>
            
            <div className="classwise-students-archive-toggle">
              <button 
                className={`classwise-students-archive-btn ${showArchived ? 'classwise-students-active' : ''}`}
                onClick={() => setShowArchived(!showArchived)}
              >
                <FontAwesomeIcon icon={showArchived ? faCheckCircle : faArchive} />
                {showArchived ? 'Hide Archived' : 'Show Archived'}
              </button>
            </div>
          </div>
          
          <div className="classwise-students-controls-right">
            {selectedRows.size > 0 && (
              <div className="classwise-students-selection-actions">
                <span className="classwise-students-selection-count">
                  {selectedRows.size} selected
                </span>
                <button className="classwise-students-btn-action classwise-students-danger" onClick={archiveSelected}>
                  <FontAwesomeIcon icon={faArchive} />
                  Archive Selected
                </button>
                <button className="classwise-students-btn-action classwise-students-success" onClick={restoreSelected}>
                  <FontAwesomeIcon icon={faSync} />
                  Restore Selected
                </button>
              </div>
            )}
          </div>
        </div>
        
        <div className="classwise-students-filters-panel">
          <div className="classwise-students-filters-header">
            <h3>
              <FontAwesomeIcon icon={faFilter} />
              Filter Students
            </h3>
            <button className="classwise-students-btn-clear-filters" onClick={clearFilters}>
              <FontAwesomeIcon icon={faTimes} />
              Clear Filters
            </button>
          </div>
          
          <div className="classwise-students-filters-grid">
            <div className="classwise-students-filter-group">
              <label>
                <FontAwesomeIcon icon={faSchool} />
                Class
              </label>
              <select 
                value={filters.class}
                onChange={(e) => handleFilterChange("class", e.target.value)}
                className="classwise-students-filter-select"
              >
                <option value="">All Classes</option>
                {availableClasses.map((cls, index) => (
                  <option key={index} value={cls}>{cls}</option>
                ))}
              </select>
            </div>
            
            <div className="classwise-students-filter-group">
              <label>
                <FontAwesomeIcon icon={faLayerGroup} />
                Section
              </label>
              <select 
                value={filters.section}
                onChange={(e) => handleFilterChange("section", e.target.value)}
                className="classwise-students-filter-select"
                disabled={!filters.class}
              >
                <option value="">All Sections</option>
                {availableSections.map((section, index) => (
                  <option key={index} value={section}>{section}</option>
                ))}
              </select>
            </div>
            
            <div className="classwise-students-filter-group">
              <label>
                <FontAwesomeIcon icon={faUserFriends} />
                Family Status
              </label>
              <select 
                value={filters.family_status}
                onChange={(e) => handleFilterChange("family_status", e.target.value)}
                className="classwise-students-filter-select"
              >
                <option value="">All</option>
                <option value="solo">Solo</option>
                <option value="family">Family</option>
              </select>
            </div>
            
            <div className="classwise-students-filter-group">
              <label>
                <FontAwesomeIcon icon={faCode} />
                Family Code
              </label>
              <input
                type="text"
                value={filters.family_code}
                onChange={(e) => handleFilterChange("family_code", e.target.value)}
                placeholder="Enter family code"
                className="classwise-students-filter-input"
              />
            </div>
            
            <div className="classwise-students-filter-group">
              <label>
                <FontAwesomeIcon icon={faClipboardCheck} />
                Attendance
              </label>
              <select 
                value={filters.attendance}
                onChange={(e) => handleFilterChange("attendance", e.target.value)}
                className="classwise-students-filter-select"
              >
                <option value="">All</option>
                <option value="present">Present Today</option>
                <option value="absent">Absent Today</option>
              </select>
            </div>
            
            <div className="classwise-students-filter-group">
              <label>
                <FontAwesomeIcon icon={faCheckCircle} />
                Active Status
              </label>
              <select 
                value={filters.active_status}
                onChange={(e) => handleFilterChange("active_status", e.target.value)}
                className="classwise-students-filter-select"
              >
                <option value="">All</option>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
            </div>
            
            <div className="classwise-students-filter-group classwise-students-search-group">
              <div className="classwise-students-search-container">
                <input
                  type="text"
                  value={filters.search}
                  onChange={handleSearch}
                  placeholder="Search by name, ID, mobile, family code..."
                  className="classwise-students-search-input"
                />
                <button className="classwise-students-search-btn">
                  <FontAwesomeIcon icon={faSearch} />
                </button>
              </div>
            </div>
          </div>
          
          {(filters.class || filters.section || filters.family_status || filters.family_code || filters.search || filters.attendance || filters.active_status) && (
            <div className="classwise-students-active-filters">
              <span className="classwise-students-active-filters-label">Active Filters:</span>
              {filters.class && (
                <span className="classwise-students-filter-tag">
                  Class: {filters.class}
                  <FontAwesomeIcon icon={faTimes} onClick={() => handleFilterChange("class", "")} />
                </span>
              )}
              {filters.section && (
                <span className="classwise-students-filter-tag">
                  Section: {filters.section}
                  <FontAwesomeIcon icon={faTimes} onClick={() => handleFilterChange("section", "")} />
                </span>
              )}
              {filters.family_status && (
                <span className="classwise-students-filter-tag">
                  Status: {filters.family_status}
                  <FontAwesomeIcon icon={faTimes} onClick={() => handleFilterChange("family_status", "")} />
                </span>
              )}
              {filters.family_code && (
                <span className="classwise-students-filter-tag">
                  Family Code: {filters.family_code}
                  <FontAwesomeIcon icon={faTimes} onClick={() => handleFilterChange("family_code", "")} />
                </span>
              )}
              {filters.attendance && (
                <span className="classwise-students-filter-tag">
                  Attendance: {filters.attendance}
                  <FontAwesomeIcon icon={faTimes} onClick={() => handleFilterChange("attendance", "")} />
                </span>
              )}
              {filters.active_status && (
                <span className="classwise-students-filter-tag">
                  Active: {filters.active_status}
                  <FontAwesomeIcon icon={faTimes} onClick={() => handleFilterChange("active_status", "")} />
                </span>
              )}
              {filters.search && (
                <span className="classwise-students-filter-tag">
                  Search: {filters.search}
                  <FontAwesomeIcon icon={faTimes} onClick={() => handleFilterChange("search", "")} />
                </span>
              )}
            </div>
          )}
        </div>
        
        <div className="classwise-students-results-summary">
          <div className="classwise-students-summary-left">
            <h4>
              <FontAwesomeIcon icon={faTable} />
              Student Records
            </h4>
            <span className="classwise-students-results-count">
              Showing {filteredStudents.length} of {students.length} students
              {filters.search && ` matching "${filters.search}"`}
              <span className="classwise-students-status-summary">
                ({stats.active} active, {stats.inactive} inactive)
              </span>
            </span>
          </div>
          <div className="classwise-students-summary-right">
            <button 
              className="classwise-students-btn-export-csv"
              onClick={() => {
                alert('CSV export feature coming soon!');
              }}
            >
              <FontAwesomeIcon icon={faFileExport} />
              Export CSV
            </button>
          </div>
        </div>
        
        {loading ? (
          <div className="classwise-students-loading-container">
            <FontAwesomeIcon icon={faSpinner} spin />
            <p>Loading student data...</p>
          </div>
        ) : (
          <>
            {filteredStudents.length === 0 ? (
              <div className="classwise-students-empty-state">
                <FontAwesomeIcon icon={faUsers} />
                <h3>No students found</h3>
                <p>Try adjusting your filters or search criteria</p>
                <button className="classwise-students-btn-clear-filters" onClick={clearFilters}>
                  Clear All Filters
                </button>
              </div>
            ) : (
              <div className="classwise-students-table-container">
                <div className="classwise-students-table-wrapper">
                  <table className="classwise-students-students-table">
                    <thead>
                      <tr>
                        <th className="classwise-students-select-column">
                          <input 
                            type="checkbox"
                            checked={selectedRows.size === filteredStudents.length && filteredStudents.length > 0}
                            onChange={selectAllRows}
                            className="classwise-students-select-all-checkbox"
                          />
                        </th>
                        <th onClick={() => handleSort('student_id')} className="classwise-students-sortable">
                          Student ID <FontAwesomeIcon icon={getSortIcon('student_id')} />
                        </th>
                        <th onClick={() => handleSort('name')} className="classwise-students-sortable">
                          Student Name <FontAwesomeIcon icon={getSortIcon('name')} />
                        </th>
                        <th onClick={() => handleSort('father_name')} className="classwise-students-sortable">
                          Father Name <FontAwesomeIcon icon={getSortIcon('father_name')} />
                        </th>
                        <th onClick={() => handleSort('mobile')} className="classwise-students-sortable">
                          Mobile <FontAwesomeIcon icon={getSortIcon('mobile')} />
                        </th>
                        <th className="classwise-students-attendance-col">
                          Attendance
                        </th>
                        <th onClick={() => handleSort('class')} className="classwise-students-sortable">
                          Class <FontAwesomeIcon icon={getSortIcon('class')} />
                        </th>
                        <th onClick={() => handleSort('section')} className="classwise-students-sortable" >
                          Section <FontAwesomeIcon icon={getSortIcon('section')} />
                        </th>
                        <th onClick={() => handleSort('family_status')} className="classwise-students-sortable">
                          Family Status <FontAwesomeIcon icon={getSortIcon('family_status')} />
                        </th>
                        <th onClick={() => handleSort('family_code')} className="classwise-students-sortable">
                          Family Code <FontAwesomeIcon icon={getSortIcon('family_code')} />
                        </th>
                        <th>Active Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredStudents.map((student) => (
                        <tr key={student.id} className={`${selectedRows.has(student.id) ? 'classwise-students-selected' : ''} ${student.archived ? 'classwise-students-archived' : ''}`}>
                          <td className="classwise-students-select-column">
                            <input 
                              type="checkbox"
                              checked={selectedRows.has(student.id)}
                              onChange={() => toggleRowSelection(student.id)}
                              className="classwise-students-row-checkbox"
                            />
                          </td>
                          <td>
                            <div className="classwise-students-student-id-cell">
                              <FontAwesomeIcon icon={faIdCard} />
                              <span>{student.student_id}</span>
                            </div>
                          </td>
                          <td>
                            <div className="classwise-students-student-name-cell">
                              <div className="classwise-students-student-avatar">
                                <FontAwesomeIcon icon={faUserCircle} className={`classwise-students-avatar-icon ${student.gender === 'Male' ? 'classwise-students-male' : 'classwise-students-female'}`} />
                              </div>
                              <div className="classwise-students-student-info">
                                <strong>{student.name}</strong>
                                <small>{student.email}</small>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className="classwise-students-father-name-cell">
                              <FontAwesomeIcon icon={faUser} />
                              <span>{student.father_name}</span>
                            </div>
                          </td>
                          <td>
                            <div className="classwise-students-mobile-cell">
                              <FontAwesomeIcon icon={faPhone} />
                              <span>{student.mobile}</span>
                            </div>
                          </td>
                          <td>
                            <span className={`classwise-students-attendance-badge ${student.isAbsentToday ? 'classwise-students-absent' : 'classwise-students-present'}`}>
                              <FontAwesomeIcon icon={student.isAbsentToday ? faTimesCircle : faCheckCircle} />
                              {student.isAbsentToday ? 'Absent' : 'Present'}
                            </span>
                          </td>
                          <td>
                            <span className="classwise-students-class-badge">
                              <FontAwesomeIcon icon={faGraduationCap} />
                              {student.class}
                            </span>
                          </td>
                          <td>
                            <span 
                              className="classwise-students-section-badge" 
                              style={{ 
                                display: 'inline-flex',
                                whiteSpace: 'nowrap',
                                width: 'auto',
                                minWidth: 'max-content',
                                padding: '4px 12px',
                                justifyContent: 'center'
                              }}
                            >
                              {student.section}
                            </span>
                          </td>
                          <td>
                            <span className={`classwise-students-family-status ${student.family_status}`}>
                              <FontAwesomeIcon icon={student.family_status === 'family' ? faUserFriends : faUser} />
                              {student.family_status}
                            </span>
                          </td>
                          <td>
                            <div className="classwise-students-family-code-cell">
                              <FontAwesomeIcon icon={faCode} />
                              <span className="classwise-students-family-code-value">
                                {student.family_code || 'N/A'}
                              </span>
                            </div>
                          </td>
                          <td>
                            <span className={`classwise-students-status-badge ${student.active_status === 'active' ? 'classwise-students-status-active' : 'classwise-students-status-inactive'}`}>
                              <FontAwesomeIcon icon={student.active_status === 'active' ? faCheckCircle : faTimesCircle} />
                              {student.active_status === 'active' ? 'Active' : 'Inactive'}
                            </span>
                          </td>
                          <td>
                            <div className="classwise-students-action-buttons">
                              <button 
                                className="classwise-students-btn-view"
                                onClick={() => openModal(student)}
                                title="View Details"
                              >
                                <FontAwesomeIcon icon={faEye} />
                              </button>
                              
                              
                              <button 
  className={`classwise-students-btn-ban ${blinkingButtonId === student.id ? 'classwise-students-blinking' : ''}`}
  onClick={() => handleBanStudent(student)}
  title={student.active_status === 'active' ? 'Ban Student' : 'Activate Student'}
  disabled={updatingStudentId === student.id}
  style={{ 
    color: student.active_status === 'active' ? '#dc2626' : '#16a34a',
    animation: student.active_status === 'inactive' ? 'classwise-students-blinking-green 1s infinite' : 'none',
    opacity: updatingStudentId === student.id ? 0.7 : 1,
    cursor: updatingStudentId === student.id ? 'not-allowed' : 'pointer'
  }}
>
  {updatingStudentId === student.id ? (
    <FontAwesomeIcon icon={faSpinner} spin />
  ) : (
    <FontAwesomeIcon icon={student.active_status === 'active' ? faBan : faCheck} />
  )}
</button>

                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                
                {!showAllStudents && filteredStudents.length > 20 && (
                  <div className="classwise-students-view-all-footer">
                    <button className="classwise-students-btn-view-all" onClick={() => setShowAllStudents(true)}>
                      <FontAwesomeIcon icon={faEyeOpen} />
                      View All {filteredStudents.length} Students
                    </button>
                  </div>
                )}
              </div>
            )}
          </>
        )}
        
        {isModalOpen && selectedStudent && (
          <div className={`classwise-students-modal-overlay ${isModalVisible ? 'classwise-students-visible' : ''}`} onClick={closeModal}>
            <div className="classwise-students-modal-container" onClick={(e) => e.stopPropagation()}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "16px 20px",
                  borderBottom: "1px solid #e5e7eb",
                  backgroundColor: "#f9fafb"
                }}
              >
                {/* Title Section */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "14px"
                  }}
                >
                  {/* Avatar */}
                  <div
                    style={{
                      width: "44px",
                      height: "44px",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor:
                        selectedStudent.gender === "Male" ? "#eff6ff" : "#fdf2f8",
                      color:
                        selectedStudent.gender === "Male" ? "#2563eb" : "#db2777",
                      fontSize: "22px"
                    }}
                  >
                    <FontAwesomeIcon icon={faUserCircle} />
                  </div>

                  {/* Title Text */}
                  <div>
                    <h3
                      style={{
                        margin: 0,
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#111827"
                      }}
                    >
                      {selectedStudent.name}
                    </h3>
                    <p
                      style={{
                        margin: "2px 0 0",
                        fontSize: "12px",
                        color: "#6b7280"
                      }}
                    >
                      {selectedStudent.student_id} | {selectedStudent.class}-{selectedStudent.section}
                    </p>
                  </div>
                </div>

                {/* Close Button */}
                <button
                  onClick={closeModal}
                  style={{
                    background: "transparent",
                    border: "none",
                    color: "#6b7280",
                    fontSize: "16px",
                    cursor: "pointer",
                    padding: "6px",
                    borderRadius: "6px"
                  }}
                  title="Close"
                >
                  <FontAwesomeIcon icon={faTimes} />
                </button>
              </div>
              
              <div className="classwise-students-modal-body">
                <div className="classwise-students-modal-tabs">
                  <button 
                    className={`classwise-students-tab-btn ${activeTab === 'studentDetails' ? 'classwise-students-active' : ''}`}
                    onClick={() => setActiveTab('studentDetails')}
                  >
                    <FontAwesomeIcon icon={faUser} />
                    Student Details
                  </button>
                  <button 
                    className={`classwise-students-tab-btn ${activeTab === 'testReport' ? 'classwise-students-active' : ''}`}
                    onClick={() => setActiveTab('testReport')}
                  >
                    <FontAwesomeIcon icon={faClipboardList} />
                    Test Report
                  </button>
                  <button 
                    className={`classwise-students-tab-btn ${activeTab === 'examReport' ? 'classwise-students-active' : ''}`}
                    onClick={() => setActiveTab('examReport')}
                  >
                    <FontAwesomeIcon icon={faBookOpen} />
                    Exam Report
                  </button>
                  <button 
                    className={`classwise-students-tab-btn ${activeTab === 'attendanceReport' ? 'classwise-students-active' : ''}`}
                    onClick={() => setActiveTab('attendanceReport')}
                  >
                    <FontAwesomeIcon icon={faChartPie} />
                    Attendance Report
                  </button>
                </div>
                
                <div className="classwise-students-modal-content">
                  {renderTabContent()}
                </div>
              </div>
              
              <div className="classwise-students-modal-footer">
                <button className="classwise-students-btn-secondary" onClick={closeModal}>
                  Close
                </button>
                <button className="classwise-students-btn-primary" onClick={() => {
                  closeModal();
                  navigate(`/Edit-Students-Data?id=${selectedStudent.id}`);
                }}>
                  <FontAwesomeIcon icon={faEdit} />
                  Edit Student
                </button>
                <button 
                  className={`classwise-students-btn-${selectedStudent.active_status === 'active' ? 'danger' : 'success'}`}
                  onClick={() => handleBanStudent(selectedStudent)}
                >
                  <FontAwesomeIcon icon={selectedStudent.active_status === 'active' ? faBan : faCheck} />
                  {selectedStudent.active_status === 'active' ? 'Ban Student' : 'Activate Student'}
                </button>
              </div>
            </div>
          </div>
        )}
        
        <footer className="classwise-students-page-footer">
          <div className="classwise-students-footer-content">
            <div className="classwise-students-footer-brand">
              <FontAwesomeIcon icon={faSchool} />
              <span>School Management System</span>
            </div>
            <div className="classwise-students-footer-info">
              <span>Total: {stats.total} students</span>
              <span>•</span>
              <span>Active: {stats.active}</span>
              <span>•</span>
              <span>Inactive: {stats.inactive}</span>
              <span>•</span>
              <span>Absent Today: {todayAbsentCount}</span>
              <span>•</span>
              <span>Last Updated: {new Date().toLocaleTimeString()}</span>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default ClasswiseStudents;